export const NAME = 'MultiHistoricalFlightStatus';
